import React, { useState } from "react";
import { Permission } from "../../Common/layout/Permission";
import { Permissions, PermissionType } from "../../../util/Permissions";
import CreateBonusSharePaymentModal from "./modals/CreateBonusSharePaymentModal";
import { ContentRoute } from "../../../../_metronic/layout";
import { BonusShareDetails } from "./BonusShareDetails";
import { useGetBonusSharesHistoryQuery } from "../../../../redux/apiSlice";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";

export const BonusShares = ({ instrumentId, symbol }) => {

    /* Bonus Shares Modal State Management */
    const [bonusSharesModal, setBonusSharesModal] = useState({ showCreateBonusSharePaymentModal: false, details: null });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setBonusSharesModal({ ...bonusSharesModal, [modal]: !bonusSharesModal[modal] })
    }

    /* Fetch Bonus Shares History */
    const { data: bonusShares } = useGetBonusSharesHistoryQuery(instrumentId)

    return <>
        <div className="d-flex h-100">
            <div
                style={{ "width": "280px" }}
                className="border-right d-flex flex-column"
            >
                <div className="py-4 px-5">
                    <p className="text-truncate font-weight-bold m-0">{symbol}</p>
                    <p className="text-muted m-0">Bonus Shares History</p>
                </div>
                <div className="col px-0 overflow-auto">
                    {
                        bonusShares?.data?.map((bonusShare, i) => (
                            <AsideMenu.NavItem key={bonusShare?.autoId} to={`/holdings/${bonusShare?.instrumentId}/bonus-shares/${bonusShare?.autoId}`}>
                                <div className="d-flex align-items-center">
                                    <div className="flex-column align-items-start">
                                        <div>
                                            {bonusShare?.qualificationDate}
                                        </div>
                                        <div className="text-muted">
                                            {`${bonusShare?.quantity} for ${bonusShare?.shareBasis} share(s).`}
                                        </div>
                                    </div>
                                </div>
                            </AsideMenu.NavItem>
                        ))
                    }
                </div>
                <Permission permission={Permissions.PROFILE} permissionType={PermissionType.CREATE}>
                    <div className="bg-white border-top mx-5">
                        <button
                            className={`btn btn-dark w-100 h-40 my-2 my-lg-3`}
                            onClick={toggleModal("showCreateBonusSharePaymentModal")}
                        >
                            New Bonus Share Payment
                        </button>
                    </div>
                </Permission>
            </div>
            <div className="col px-0">
                <ContentRoute
                    path="/holdings/:instrumentId/bonus-shares/:bonusShareId"
                    permission={Permissions.HOLDINGS}
                    component={(props) => <BonusShareDetails {...props} symbol={symbol} />}
                />
            </div>
        </div>

        <CreateBonusSharePaymentModal
            {...bonusSharesModal}
            instrumentId={instrumentId}
            symbol={symbol}
            onHide={toggleModal("showCreateBonusSharePaymentModal")}
        />
    </>
}